import { LngLat, MercatorCoordinate, type Map as MapLibreMap } from 'maplibre-gl';
import { cameraVerticalFieldOfView } from '../domain/camera-optics';

interface PhysicalCamera {
  ground: readonly [number, number]; altitude: number;
  center: readonly [number, number]; aim: number;
}

/** Bound pursuit drift by the physical view instead of the automatic whole-route framing. */
export function physicalCameraFollowZoom(map: MapLibreMap, lens: number, altitude: number, tilt: number,
  target: readonly [number, number]): number {
  const canvas = map.getCanvas(), height = canvas.clientHeight, width = canvas.clientWidth || height * 16 / 9;
  const field = cameraVerticalFieldOfView(lens, width, height) * Math.PI / 360;
  const scale = MercatorCoordinate.fromLngLat([...target], 0).meterInMercatorCoordinateUnits();
  const slant = altitude * scale / Math.cos(Math.min(85, Math.abs(tilt)) * Math.PI / 180);
  return Math.log2(height / (2 * Math.tan(field) * 512 * slant));
}

/** Apply focal length without compensating for camera height or Target Lock. */
export function physicalCameraOptions(map: MapLibreMap, sample: PhysicalCamera, lens: number) {
  const canvas = map.getCanvas(), height = canvas.clientHeight, width = canvas.clientWidth || height * 16 / 9;
  map.setMaxZoom(24);
  map.setVerticalFieldOfView(cameraVerticalFieldOfView(lens, width, height));
  const camera = map.calculateCameraOptionsFromTo(new LngLat(...sample.ground), sample.altitude,
    new LngLat(...sample.center), sample.aim);
  if (camera.zoom !== undefined && camera.zoom > 24) throw new RangeError('This lens and altitude exceed the map camera limit. Raise the altitude or use a shorter lens.');
  return camera;
}
